<template lang="pug">
  #login
    .container.h-100
      .d-flex.flex-row.flex-wrap.align-content-center.justify-content-center.h-100
        .d-flex.col-12.align-self-end.justify-content-center
          p
            a.logo-amulen.mb-4
        .d-flex.col-6.align-self-top.justify-content-center
          .card.w-100
            .card-body.p-5
                slot
</template>

<script>
export default {

  name: 'LoginLayout',

  data () {
    return {

    }
  }
}
</script>
<style lang="stylus" scoped>
  #login
    background #eee
    height 100%
    width 100%
</style>
